export default __webpack_public_path__ + "static/media/COMCOM.53abec3e.webp";